
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  skipLLM: true,
  maxTocLevel: 4,
  description: "Use Atomic and Plaid to pull user transactions and identify a user's payroll and subscriptions"
};
export const partnerProps = {
  partner: 'Atomic Financial',
  clientLibrary: 'atomicfi',
  subtitle: metadata.description,
  registrationUrl: 'https://atomic.financial/contact-sales/',
  apiUrl: 'https://docs.atomicfi.com',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Atomic have partnered to help financial institutions and fintech platforms unlock actionable intelligence from transaction data — without asking customers to re-link their accounts. Atomic's PayDetect product works with Plaid transaction data to power two distinct capabilities:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`PayDetect: Income Source Detection`}</strong>{` — Identifies a customer's payroll provider or employer from incoming deposit transactions, enabling direct deposit switch flows that route paychecks to your account.`}</li>
      <li parentName="ul"><strong parentName="li">{`PayDetect: Recurring Payment Detection`}</strong>{` — Identifies a customer's recurring payments and subscriptions on external accounts and maps to Atomic's coverage, powering subscription management experiences, payment update flows, and merchant connectivity features.`}</li>
    </ul>
    <p>{`Both capabilities use a Plaid processor token passed from your application to Atomic. No additional transaction integration is required — Atomic retrieves the data and uses it to power personalized experiences for your end users directly within the Atomic SDK.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
